export default "__VITE_ASSET__ZKm_K3X___"